import { Provider } from '@angular/core';
import { HttpAgeGroupsService } from '@daas-consulting/production/age_groups/frontend/data_access';
import { AgeGroupsServiceId } from '@daas-consulting/production/age_groups/frontend/data_contracts';

export const AgeGroupsServiceProvider: Provider = {
  provide: AgeGroupsServiceId,
  useClass: HttpAgeGroupsService,
};
